import { Injectable } from '@angular/core';
import { EMPTY } from 'rxjs';
import { DnaAlertService } from './dna-alert.service';

// Ponte: substitui o MatSnackBar pelo banner dna-alert (padrão SSO).
// Todas as chamadas snackBar.open(...) existentes passam a exibir o alerta DNA
// sem precisar alterar os pontos de chamada.
@Injectable()
export class DnaSnackBarService {

  constructor(private alertService: DnaAlertService) {}

  open(message: string, _action?: string, _config?: any): any {
    const text = (message ?? '').toString();

    if (/sucesso/i.test(text)) {
      this.alertService.success(text);
    } else if (/^nenhum registro/i.test(text)) {
      this.alertService.info(text);
    } else {
      this.alertService.error(text);
    }

    // Stub compatível com MatSnackBarRef para os usos existentes
    return {
      _dismissAfter: (_ms: number) => {},
      dismiss: () => {},
      dismissWithAction: () => {},
      onAction: () => EMPTY,
      afterDismissed: () => EMPTY,
      afterOpened: () => EMPTY,
    };
  }

  dismiss(): void {
    this.alertService.clear();
  }
}
